import { en } from 'vuetify/lib/locale'

export default {
  ...en,
  lang: "English",
  
  login: "Log in",
  logout: "Logout",

  // User
  username: "Username",
  email: "Email",
  password: "Password",
  
  user: "User",
  user_menu: {
    process_map_image: "Process Map Image",
    change_password: "Change Password",
  },

  inactivity_title: "INACTIVITY WARNING",
  check_inactivity_warning_1: "Your session is about to expire. If you wish to continue on the page, click Continue.",
  check_inactivity_warning_2: "Seconds until automatic disconnection: ",

  identify: "Identify",
  add: "Add",
  delete: "Delete",
  search_text: "Search...",
  loading: "Loading...",
  select: "Select",
  limit: "Limit",
  type: "Type",
  confirm: "Yes",
  denny: "No",
  not_found: "Not found",
  text_new: "New",
  text_modify: "Modify",
  text_equal:"Equal",
  text_legend:"Legend",
  max_file_size_reached: "Max form files size reached (19Mb).\n Remove some files or decrease its weight.",

  labels: {
    name: "Name",
    description: "Descrition",
    weight: "Weight",
    number: "Number",
    units: "Unidades",
    document: "Document",
    report: "Report",
    report_list: "List",
    parent_roles_inheritance: "Parent Roles Inheritance",
  },

  dialog: {
    save: "Save",
    cancel: "Cancel",
    send: "Send",
    clear: "Clear",
    delete: "Delete",
    confirm: "Confirm",
  },

  filters: {
    processes: {
      process: "Process filter",
      processes_selected: "Selected processes",
    },
    dates: {
      date_range: "Choose date range",
      dates_selected: "Selected dates",
      date_field: "Choose Field",
      date1_lower: "Finish Date can't be earlier than Start Date",
    },
    advanced: {
      filters: "Filters",
      title: "Filter conditions",
    },
    type: "Type filter",
  },

  week_days: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",

    short: {
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun",
    }
  },

  month_names: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
  },

  monthly: "Monthly",
  weekly: "Weekly",
  daily: "Daily",

  go_to_today: "Go to today",
  calendar_type: "Current display mode",
  current_day_interval: "Current day range",

  no_process_map: "There is no process map configured",
  required_field: "Required field",
  duplicate_value: "The value is not valid. Duplicate",
  copied: "Copied",

  invalid_value: "Invalid value",
  invalid_date: "Invalid date",
  invalid_hour: "Invalid hour",
  invalid_minute: "Invalid minutes",
  invalid_negative_number: "Negative numbers are not allowed",
  bigger_than: "The value must be greater than",
  smaller_than: "The value must be less than",

  password_form: {
    current_password: "Password",
    new_password: "New password",
    confirm_new_password: "Confirm new password",

    input_current_password: "Enter current password",
    input_new_password: "Enter new password",
    reinput_new_password: "Re-enter new password",
    pattern_error: "Min. 8 characters with at least one capital letter, a number and a special character.",
    password_no_match: "Password no match",
    password_different: "New Password must be different",
  },

  notifications: {
    title: "User notifications",
  },

  pagination: {
    page: "Elements per page",
    page_mobile: "Page",
    of: "of",
  },

  explorer: {
    no_data: "Results not found",
    no_views: "No views available",
  },

  views: {
    table: "Table",
    cards: "Cards",
    calendar: "Calendar",
    charts: "Charts",
    processes: {
      tabs: {
        data: "Data",
        permissions: "Permissions"
      },
      add_process: "Add process",
      edit_process: "Edit process",
      delete_process: "Delete process",
      add_permission: "Add permission",
      edit_permission: "Edit permission",
      delete_permission: "Delete permission",
      process_fields: {
        process_id: "Id",
        internal_type: "Type of internal process",
        internal_type_placeholder: "Select internal process type",
        bp_reference: "Internal reference",
        bp_reference_placeholder: "Enter internal process reference",
        inherit_permissions: "Inherit permissions?",
        inherit_permissions_placeholder: "Select If Process inherit roles/permissions",
        reference: "Reference",
        reference_placeholder: "Enter process reference",
        name: "Name",
        name_placeholder: "Enter process name",
        process_type: "Process type",
        process_type_placeholder: "Select process type",
        description: "Descripction",
        description_placeholder: "Enter process description",
        entries: "Entries",
        entries_placeholder: "Enter proces entries",
        outputs: "Outputs",
        outputs_placeholder: "Enter process outputs",
        activities: "Activities",
        activities_placeholder: "Enter process activities",
        objective: "Objetive",
        objective_placeholder: "Enter process objetive",
        scope: "Scope",
        scope_placeholder: "Enter process scope",
        process_roles_text: "PROCESS ROLES",
        responsible_roles: "Process Responsible Roles",
        responsible_roles_placeholder: "Select responsible roles for the process",
        creator_roles: "Process Creator Roles",
        creator_roles_placeholder: "Select roles that can create QUnits that implement the process",
        editor_roles: "Process Editor Roles",
        editor_roles_placeholder: "Select roles that can execute all transitions of the QUnits that implement the process",
        reader_roles: "Process Reader Roles",
        reader_roles_placeholder: "Roles that can be read by all QUnits implementing the process. Download PDF",
        original_document_reader_roles: "Process reader roles. Download original",
        original_document_reader_roles_placeholder: "Roles that can be read by all QUnits implementing the process. Download original",
        visor_pdf_reader_roles: "Process reader roles. PDF viewer only",
        visor_pdf_reader_roles_placeholder: "Roles that can be read by all QUnits implementing the process. Download PDF only",
        parent: "Parent",
      },
      permission_fields: {
        permission_id: "Permission id",
        roles_allowed: "Allowed roles",
        departments_allowed: "Allowed Departments",
      },
      process_types: {
        core: "Core",
        strategic: "Strategic",
        support: "Support",
       },
       internal_type: {
        public: "Public",
        restricted: "Restricted",
       },
      standard: {
        add: "Add Standard",
        name_placeholder: "Enter Standard Name"
      },
    },
  },

  inputs: {
    directory: "Folder",
    current_file: "Current file",
    file_too_big: "The size must be less than 20 MiB!",
    file_type_not_identified: "Cannot identify file type",
    file_not_valid: "The file is invalid",
    email_invalid: "E-mail must be valid",
    start_space: "It has a space at the beginning",
    link_invalid: "Link must be valid",
  },

  indicators: {
    weight: "Weight",
    measure_type: "Select the type of measure",
    new_measure: "New measure",
    percentage: "Percentage",
    invalid_percentage: "Invalid Percentage",
    indicator_label: "Indicator",
    new_measure_modal: "Measures: New measure",
    measures_types_names: {
      "category": "Category",
      "number": "Number",
      "indicator": "Sub-indicator",
    },
    variable_type: "Variable type",
    allow_negative: "Allow negative values?",
    units_placeholder: "Unit name. Eg: kg, m, l, kW/h...",
    num_types: {
      integer: "Integer",
      decimal: "Decimal",
      },
  },

  directory: {
    directory: "Folder",
    no_directory: "No folders found",
    add_directory: "Add folder",
    add_subdirectory: "Add subfolder",
    edit_directory: "Edit folder",
    delete_directory: "Delete folder",
    father: "Father",
    select_father: "Select father folder",
    directory_name: "Name",
    select_parent_directory: "Select the parent folder",
    not_able_to_delete: "Can't delete folder",
    level: "Level",
    route: "Route",
  },

  footer: {
    contact: "Contact",
    help: "Help",
  },

  actions: {
    generic_download_evidence_options: {
      current_version: "Current Version",
      draft: "Draft",
    },
    view_qunit: {
      data: "Data",
    },
  },

  inlineboxes: {
    inlinebox_data: {
      copy_email: "Copy email code",
      responsible: "Responsible",
    },
  },

  chips: {
    value: "Value",
    process: "Process",
  },

  reports:{
    info:"Your report is being generated ...",
    success: "The report has been generated",
    error: "Error: The report could not be generated",
  },

  indicator: {
    numbers: "Numeric.",
    int: "Integers.",
    float: "Decimals.",
    positive: "Only positive values",
    units: 'Units',
  },
};
